/** Breadcrumb segments for administration screens (C1ListPanel). */

/** Canonical healthcare landing dashboard route. */
export const DASHBOARD_DEFAULT_PATH = "/dashboard/default";

const ADMIN_ROOT = {
  name: "Administration",
  path: DASHBOARD_DEFAULT_PATH,
  showSelection: true,
};

/** Primary module administration overview route. */
export const MODULE_ADMIN_OVERVIEW_PATH = "/users/manage-roles";

/** @param {string} moduleKey */
export function moduleAdminDetailPath(moduleKey) {
  return `${MODULE_ADMIN_OVERVIEW_PATH}/${encodeURIComponent(moduleKey)}`;
}

export const accountsListSegments = [
  ADMIN_ROOT,
  { name: "User management", path: "/account/manage-account" },
  { name: "Accounts" },
];

export const coreRolesListSegments = [
  ADMIN_ROOT,
  { name: "Access control", path: "/roles/manage-roles" },
  { name: "Core roles" },
];

export const userRolesListSegments = [
  ADMIN_ROOT,
  { name: "User management", path: MODULE_ADMIN_OVERVIEW_PATH },
  { name: "All assignments" },
];

export const moduleAdminOverviewSegments = [
  ADMIN_ROOT,
  { name: "User management", path: MODULE_ADMIN_OVERVIEW_PATH },
  { name: "Modules" },
];

/** @param {string} moduleLabel @param {string} [moduleDescription] */
export function moduleAdminDetailSegments(moduleLabel, moduleDescription) {
  return [
    ADMIN_ROOT,
    { name: "User management", path: MODULE_ADMIN_OVERVIEW_PATH, showSelection: true },
    {
      name: moduleDescription
        ? `${moduleLabel}`
        : moduleLabel,
    },
  ];
}

/** @deprecated Phase 1 role-centric routes — use moduleAdmin* segments */
export const roleAdminOverviewSegments = moduleAdminOverviewSegments;

/** @deprecated Phase 1 role-centric routes */
export function roleAdminDetailSegments(roleId, roleDescription) {
  return moduleAdminDetailSegments(
    roleDescription ? `${roleId} — ${roleDescription}` : roleId,
    roleDescription,
  );
}

export const userProfileSegments = [ADMIN_ROOT, { name: "My profile" }];

export const doctorLinkReconciliationSegments = [
  ADMIN_ROOT,
  { name: "Data integrity", path: "/admin/data-integrity/doctor-user-links" },
  { name: "Doctor user link reconciliation" },
];

export const whatsappWalletSegments = [
  ADMIN_ROOT,
  { name: "Wallet" },
];

export const saasAutopayOpsSegments = [
  ADMIN_ROOT,
  { name: "Autopay operations" },
];

export const saasPlanAdminSegments = [
  ADMIN_ROOT,
  { name: "Subscription plans" },
];

export const whatsappMessagePricingSegments = [
  ADMIN_ROOT,
  { name: "WA message pricing" },
];

export const whatsappTemplateReviewSegments = [
  ADMIN_ROOT,
  { name: "WhatsApp templates" },
];

export const whatsappOnboardingSegments = [
  ADMIN_ROOT,
  { name: "WhatsApp sender" },
];

export const mobileAppUpdateSegments = [
  ADMIN_ROOT,
  { name: "Mobile app update" },
];

const OPERATIONS_ROOT = {
  name: "Operations",
  path: DASHBOARD_DEFAULT_PATH,
  showSelection: true,
};

export const whatsappCampaignListSegments = [
  OPERATIONS_ROOT,
  { name: "WhatsApp", path: "/admin/whatsapp-campaigns" },
  { name: "Campaigns" },
];

export function whatsappCampaignDetailSegments(title) {
  return [
    OPERATIONS_ROOT,
    { name: "WhatsApp", path: "/admin/whatsapp-campaigns" },
    { name: "Campaigns", path: "/admin/whatsapp-campaigns" },
    { name: title || "Campaign" },
  ];
}

export function whatsappCampaignEditorSegments(modeLabel) {
  return [
    OPERATIONS_ROOT,
    { name: "WhatsApp", path: "/admin/whatsapp-campaigns" },
    { name: "Campaigns", path: "/admin/whatsapp-campaigns" },
    { name: modeLabel || "Editor" },
  ];
}

export const whatsappCampaignReportsSegments = [
  OPERATIONS_ROOT,
  { name: "WhatsApp", path: "/admin/whatsapp-campaigns" },
  { name: "Campaigns", path: "/admin/whatsapp-campaigns" },
  { name: "Reports" },
];

export const whatsappMarketingTemplateSegments = [
  OPERATIONS_ROOT,
  { name: "WhatsApp", path: "/admin/whatsapp-campaigns" },
  { name: "Campaigns", path: "/admin/whatsapp-campaigns" },
  { name: "Marketing templates", path: "/admin/whatsapp-campaigns/marketing-templates" },
];

export const whatsappMarketingTemplateCreateSegments = [
  OPERATIONS_ROOT,
  { name: "WhatsApp", path: "/admin/whatsapp-campaigns" },
  { name: "Campaigns", path: "/admin/whatsapp-campaigns" },
  { name: "Marketing templates", path: "/admin/whatsapp-campaigns/marketing-templates" },
  { name: "Create" },
];

export const whatsappInboxSegments = [
  OPERATIONS_ROOT,
  { name: "WhatsApp", path: "/admin/whatsapp-inbox" },
  { name: "Inbox" },
];

